import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/AuthContext';
import { ThemeProvider } from './lib/ThemeProvider';
import { auth } from './lib/firebase';
import { QuestionnaireProvider } from './lib/QuestionnaireContext';
import Login from './components/Auth/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AdminProtectedRoute from './components/Auth/AdminProtectedRoute';
import QuestionnaireHome from './components/Questionnaire/QuestionnaireHome';
import QuestionnaireForm from './components/Questionnaire/QuestionnaireForm';
import QuestionnaireSuccess from './components/Questionnaire/QuestionnaireSuccess';
import QuestionnaireLayout from './components/Questionnaire/QuestionnaireLayout';
import AdminQuestionnaireView from './components/Questionnaire/AdminQuestionnaireView';
import QuestionnaireTemplateBuilder from './components/Admin/QuestionnaireTemplateBuilder';
import FirebaseDebug from './components/FirebaseDebug';
import './App.css';

function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <AuthProvider>
        <QuestionnaireProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/debug" element={<FirebaseDebug />} />
              
              {/* Questionnaire routes with layout */}
              <Route element={
                <ProtectedRoute>
                  <QuestionnaireLayout />
                </ProtectedRoute>
              }>
                <Route path="/questionnaire" element={<QuestionnaireHome />} />
                <Route path="/questionnaire/form" element={<QuestionnaireForm />} />
                <Route path="/questionnaire/form/:id" element={<QuestionnaireForm />} />
                <Route path="/questionnaire/success" element={<QuestionnaireSuccess />} />
                <Route path="/questionnaire/admin/view/:userId/:questionnaireId" element={
                  <AdminProtectedRoute>
                    <AdminQuestionnaireView />
                  </AdminProtectedRoute>
                } />
                <Route path="/questionnaire/admin/templates" element={
                  <AdminProtectedRoute>
                    <QuestionnaireTemplateBuilder 
                      onSave={async (template) => {
                        try {
                          // Get Firebase auth token
                          const user = auth.currentUser;
                          if (!user) throw new Error('Not authenticated');
                          
                          const token = await user.getIdToken();
                          
                          // Debug log
                          console.log('Saving template:', JSON.stringify(template, null, 2));
                          
                          // Save the active template
                          const response = await fetch('https://api-reuvze3ckq-uc.a.run.app/api/questionnaire-templates/active', {
                            method: 'PUT',
                            headers: {
                              'Authorization': `Bearer ${token}`,
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(template)
                          });
                          
                          if (!response.ok) {
                            // Get the error details
                            const errorText = await response.text();
                            throw new Error(`Failed to save: ${response.statusText}. Details: ${errorText}`);
                          }
                          
                          const savedTemplate = await response.json();
                          console.log('Template saved successfully:', savedTemplate);
                          
                          // Clear any cached templates in the context
                          if ((window as any).clearTemplateCache) {
                            (window as any).clearTemplateCache();
                          }
                          
                          alert('Questionnaire updated successfully!');
                        } catch (error) {
                          console.error('Error saving template:', error);
                          alert('Failed to save questionnaire. Please try again.');
                        }
                      }}
                      onCancel={() => {
                        // Navigate back to admin panel
                        window.history.back();
                      }}
                    />
                  </AdminProtectedRoute>
                } />
                <Route path="/" element={<Navigate to="/questionnaire" replace />} />
              </Route>
            </Routes>
          </Router>
        </QuestionnaireProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
